import React from 'react';

/**
 * Consistent premium section: kicker → h2 → subtitle → children.
 *
 * Props:
 *   id        - section ID (for anchor linking)
 *   variant   - 'default' | 'dark' | 'gray' | 'primary'
 *   kicker    - small uppercase text above heading
 *   heading   - section h2 text
 *   subtitle  - paragraph below heading
 *   narrow    - use narrow container (800px vs 1100px)
 *   className - extra class names
 *   children  - section content
 */
const SectionWrapper = ({
  id,
  variant = 'default',
  kicker,
  heading,
  subtitle,
  narrow = false,
  className = '',
  children,
}) => {
  const variantClass =
    variant === 'dark'
      ? 'rr-section--dark'
      : variant === 'gray'
      ? 'rr-section--gray'
      : variant === 'primary'
      ? 'rr-section--primary'
      : '';

  const containerClass = narrow ? 'rr-container--narrow' : 'rr-container';

  return (
    <section id={id} className={`rr-section ${variantClass} ${className}`.trim()}>
      <div className={containerClass}>
        {kicker && <p className="rr-kicker">{kicker}</p>}
        {heading && <h2 className="rr-h2">{heading}</h2>}
        {subtitle && <p className="rr-sub">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
};

export default SectionWrapper;
